"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var NewVersionDialogComponent = /** @class */ (function () {
    function NewVersionDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.reloading = false;
    }
    NewVersionDialogComponent.prototype.ngOnInit = function () {
    };
    NewVersionDialogComponent.prototype.closeAction = function () {
        this.reloading = true;
        window.location.href = "/";
    };
    return NewVersionDialogComponent;
}());
exports.NewVersionDialogComponent = NewVersionDialogComponent;
